import { useState } from "react"
import { Box, Button, IconButton, CircularProgress } from "@mui/material"
import PhotoIcon from "@mui/icons-material/Photo"
import { Download } from "@mui/icons-material"
import { downloadPropertyImagesAsZip } from "../../services/propertyService"
import Grid from "@mui/material/Grid2"

interface PropertyGalleryProps {
  photos: string[]
  propertyId: string | number
  onViewPhotos: () => void
}

const PropertyGallery = ({ photos, propertyId, onViewPhotos }: PropertyGalleryProps) => {
  const [isDownloading, setIsDownloading] = useState(false)
  const [mainPhoto, ...otherPhotos] = photos

  const downloadImages = async () => {
    if (!photos || photos.length === 0) {
      console.error("No hay imágenes para descargar.")
      return
    }
    setIsDownloading(true)
    try {
      await downloadPropertyImagesAsZip(String(propertyId), photos)
    } catch (error: any) {
      console.error("Error al descargar el archivo ZIP:", error)
    }
    setIsDownloading(false)
  }

  return (
    <Grid container spacing={2} sx={{ mb: 4 }}>
      <Grid  size={{ xs: 12, md: 6 }}>
        <Box  onClick={onViewPhotos} 
        sx={{ width: "100%", height: "380px", overflow: "hidden", borderRadius: "8px",    
        "&:hover": 
        {
          opacity: 0.8,
        }, 
        }}>
          <img
            src={mainPhoto || "/placeholder.svg"}
            alt="Foto principal"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              borderRadius: "8px",
              display: "block",
            }}
          />
        </Box>
      </Grid>
      <Grid  size={{ xs: 12, md: 6 }}>
        <Box sx={{ position: "relative", width: "100%", height: "100%" }}>
          <Grid container spacing={2}>
            {otherPhotos.slice(0, 4).map((photo, index) => (
              <Grid  size={{ xs: 6, sm: 4, md: 6 }} key={index}>
                <Box
                  onClick={onViewPhotos}
                  sx={{
                    height: "182px",
                    overflow: "hidden",
                    borderRadius: "8px",
                    cursor: "pointer",
                    "&:hover": {
                      opacity: 0.8,
                    },
                  }}
                >
                  <img
                    src={photo || "/placeholder.svg"}
                    alt={`Foto secundaria ${index + 1}`}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      borderRadius: "8px",
                      display: "block",
                    }}
                  />
                </Box>
              </Grid>
            ))}

            {/* Botón de descarga */}
            <IconButton
              onClick={downloadImages}
              sx={{
                position: "absolute",
                right: 10,
                top: 8,
                zIndex: 1,
                backgroundColor: "rgba(255, 255, 255, 0.8)",
                color: "black",
                borderRadius: "50%",
                padding: "8px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "1rem",
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 0.9)",
                },
              }}
            >
              {isDownloading ? (
                <CircularProgress size={20} sx={{ color: "black" }} />
              ) : (
                <Download />
              )}
            </IconButton>

            {/* Botón Ver todas */}
            <Button
              variant="contained"
              onClick={onViewPhotos}
              sx={{
                position: "absolute",
                right: 10,
                bottom: 8,
                zIndex: 1,
                backgroundColor: "rgba(255, 255, 255, 0.8)",
                color: "black",
                borderRadius: "8px",
                padding: "4px 8px",
                fontSize: "0.75rem",
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 0.9)",
                },
              }}
              startIcon={<PhotoIcon />}
            >
              Ver todas las fotos
            </Button>
          </Grid>
        </Box>
      </Grid>
    </Grid>
  )
}

export default PropertyGallery
